import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Element2gr7ezmxqaln7 as Element } from '../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContext.mjs';
import {
  JobSupport3fdjh0rbee4be as JobSupport,
  JobImpl2fbttqo93wxua as JobImpl,
  JobNode2tu3g3s3xsko1 as JobNode,
} from './JobSupport.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var KeyClass;
function Key() {
  if (KeyClass === VOID) {
    class $ {}
    initMetadataForObject($, 'Key');
    KeyClass = $;
  }
  return KeyClass;
}
var Key_instance;
function Key_getInstance() {
  return Key_instance;
}
function cancel$default(cause, $super) {
  cause = cause === VOID ? null : cause;
  var tmp;
  if ($super === VOID) {
    this.na3(cause);
    tmp = Unit_instance;
  } else {
    tmp = $super.na3.call(this, cause);
  }
  return tmp;
}
var JobClass;
function Job() {
  if (JobClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Job', VOID, VOID, [Element()], [0]);
    JobClass = $;
  }
  return JobClass;
}
var NonDisposableHandleClass;
function NonDisposableHandle() {
  if (NonDisposableHandleClass === VOID) {
    class $ {
      ta4() {
      }
      ra3(cause) {
        return false;
      }
      toString() {
        return 'NonDisposableHandle';
      }
    }
    initMetadataForObject($, 'NonDisposableHandle');
    NonDisposableHandleClass = $;
  }
  return NonDisposableHandleClass;
}
var NonDisposableHandle_instance;
function NonDisposableHandle_getInstance() {
  return NonDisposableHandle_instance;
}
function invokeOnCompletion(_this__u8e3s4, invokeImmediately, handler) {
  invokeImmediately = invokeImmediately === VOID ? true : invokeImmediately;
  var tmp;
  if (_this__u8e3s4 instanceof JobSupport()) {
    tmp = _this__u8e3s4.ja3(invokeImmediately, handler);
  } else {
    var tmp_0 = handler.xa4();
    tmp = _this__u8e3s4.ia3(tmp_0, invokeImmediately, JobNode$invoke$ref(handler));
  }
  return tmp;
}
function Job_0(parent) {
  parent = parent === VOID ? null : parent;
  return new (JobImpl())(parent);
}
function ensureActive(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.cd(Key_instance);
  if (tmp0_safe_receiver == null)
    null;
  else {
    ensureActive_0(tmp0_safe_receiver);
  }
}
function ensureActive_0(_this__u8e3s4) {
  if (!_this__u8e3s4.ha2())
    throw _this__u8e3s4.ea3();
}
var ParentJobClass;
function ParentJob() {
  if (ParentJobClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ParentJob', VOID, VOID, [Job()], [0]);
    ParentJobClass = $;
  }
  return ParentJobClass;
}
function disposeOnCompletion(_this__u8e3s4, handle) {
  return invokeOnCompletion(_this__u8e3s4, VOID, new (DisposeOnCompletion())(handle));
}
var DisposeOnCompletionClass;
function DisposeOnCompletion() {
  if (DisposeOnCompletionClass === VOID) {
    class $ extends JobNode() {
      constructor(handle) {
        super();
        this.aaa_1 = handle;
      }
      xa4() {
        return false;
      }
      ua4(cause) {
        return this.aaa_1.ta4();
      }
    }
    initMetadataForClass($, 'DisposeOnCompletion');
    DisposeOnCompletionClass = $;
  }
  return DisposeOnCompletionClass;
}
function JobNode$invoke$ref(p0) {
  var l = (_this__u8e3s4) => {
    p0.ua4(_this__u8e3s4);
    return Unit_instance;
  };
  l.callableName = 'invoke';
  return l;
}
//region block: init
Key_instance = new (Key())();
NonDisposableHandle_instance = new (NonDisposableHandle())();
//endregion
//region block: exports
export {
  cancel$default as cancel$default2gzemzkga6aea,
  Key_instance as Key_instance2tirv2rj82ml4,
  NonDisposableHandle_instance as NonDisposableHandle_instance3k5b81ogrgecy,
  Job_0 as Job13y4jkazwjho0,
  Job as Job29shfjfygy86k,
  ParentJob as ParentJob1a3idoswyjefg,
  disposeOnCompletion as disposeOnCompletion1zvxmj809ax5i,
  ensureActive as ensureActive2yo7199srjlgl,
  invokeOnCompletion as invokeOnCompletion3npqdfp2wzhn6,
};
//endregion

//# sourceMappingURL=Job.mjs.map
